import styled from 'styled-components';

export const CountStyled = styled.span`
  padding-left: var(--spacing-space8);
  color: var(--color-global-grey900);
  overflow-wrap: normal;
  word-break: normal;
`;
